import { render, staticRenderFns } from "./panoramic-tour.vue?vue&type=template&id=278f7e5b&scoped=true"
import script from "./panoramic-tour.vue?vue&type=script&lang=js"
export * from "./panoramic-tour.vue?vue&type=script&lang=js"
import style0 from "./panoramic-tour.vue?vue&type=style&index=0&id=278f7e5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278f7e5b",
  null
  
)

export default component.exports